<template>
  <div>
    <v-dialog
      :fullscreen="$vuetify.breakpoint.xs"
      :transition="$vuetify.breakpoint.xs ? 'dialog-bottom-transition' : ''"
      v-model="flag"
      width="750"
      scrollable
    >
      <v-card width="750" tile class="white">
        <!-- Title bar -->
        <v-card-title
          class="py-3 px-4 text-truncate dialog-title-border dark-purple-text"
        >
          <div class="d-flex justify-center" style="width: 90%">
            <span>
              <b class="modals-title-size"> Tasks by Time Entries </b>
            </span>
          </div>
          <v-spacer></v-spacer>
          <v-icon small color="#757096" @click="closeDialog">mdi-close</v-icon>
        </v-card-title>
        <v-progress-linear
          v-if="fetchTaskEntriesLoader"
          indeterminate
          color="#2a206a"
          class="mt-n1"
        ></v-progress-linear>

        <!-- <v-spacer></v-spacer> -->
        <!-- Summarized Information Div -->
        <div class="w-100 ">
          <v-card
            elevation="0"
            class="mt-4 mb-2 pa-3 mx-4 theme-border table-header-bg rounded"
            v-if="entriesDetail"
          >
            <v-row v-if="entriesDetail" :no-gutters="$vuetify.breakpoint.xs">
              <v-col
                cols="12"
                sm="5"
                md="5"
                :class="
                  $vuetify.breakpoint.xs || $vuetify.breakpoint.sm ? '' : 'ml-6'
                "
              >
                <div class="d-flex ">
                  <span
                    class="text-capitalize font-size-14 dark-purple-text font-weight-bold px-2 py-1 body-2"
                  >
                    Tasks Pending:
                  </span>

                  <span class="dark-purple-text ml-8 mt-1 font-size-14">
                    {{ entriesDetail.pending ? entriesDetail.pending : "0" }}
                  </span>
                </div>

                <div class="d-flex">
                  <span
                    class="text-capitalize font-size-14 dark-purple-text font-weight-bold px-2 py-1 body-2"
                  >
                    Tasks Completed:
                  </span>

                  <span class="dark-purple-text mt-1 ml-4 font-size-14">
                    {{
                      entriesDetail.completed ? entriesDetail.completed : "0"
                    }}
                  </span>
                </div>

                <div class="d-flex">
                  <span
                    class="text-capitalize font-size-14 dark-purple-text font-weight-bold px-2 py-1 body-2"
                  >
                    Tasks Overdue:
                  </span>

                  <span class="dark-purple-text ml-8 mt-1 font-size-14">
                    {{ entriesDetail.overdue ? entriesDetail.overdue : "0" }}
                  </span>
                </div>
              </v-col>
              <v-col
                md="1"
                cols="1"
                class="border-right ml-n10"
                :class="!$vuetify.breakpoint.xs ? 'my-4 ' : ''"
              ></v-col>
              <v-col
                cols="12"
                md="5"
                sm="5"
                :class="$vuetify.breakpoint.xs ? '' : 'ml-6'"
              >
                <div
                  class="d-flex"
                  :class="$vuetify.breakpoint.xs ? '' : 'mt-2'"
                >
                  <span
                    class="font-size-14 text-capitalize dark-purple-text font-weight-bold px-2 py-1"
                  >
                    Assigned to Others:
                  </span>

                  <span class="dark-purple-text ml-6 mt-1 font-size-14">
                    {{
                      entriesDetail.assigned_to_others
                        ? entriesDetail.assigned_to_others
                        : "0"
                    }}
                  </span>
                </div>
                <div class="d-flex">
                  <span
                    class="text-capitalize font-size-14 dark-purple-text font-weight-bold px-2 py-1 body-2"
                  >
                    Assigned By Others:
                  </span>

                  <span class="dark-purple-text ml-5 mt-1 font-size-14">
                    {{
                      entriesDetail.assigned_by_others
                        ? entriesDetail.assigned_by_others
                        : "0"
                    }}
                  </span>
                </div>
              </v-col>
            </v-row>
          </v-card>
        </div>
        <v-data-table
          :headers="headers"
          :items="getTaskTimeEntries"
          disable-pagination
          hide-default-footer
          id="task-entries-table"
          :class="[{ edited_scrollbar: isMac }]"
          class=" mb-3 elevation-1 mx-4 rounded tables-border"
          :height="
            $vuetify.breakpoint.xs
              ? 'calc(100vh - 270px)'
              : 'calc(100vh - 400px)'
          "
          fixed-header
          :mobile-breakpoint="0"
          @click:row="redirect"
        >
          <template v-slot:[`item.id`]="{ index }">
            <span class="ml-2 dark-purple-text" style="font-size: 12px">
              {{ index + 1 }}
            </span>
          </template>
          <template v-slot:[`item.total_time`]="{ item }">
            <v-chip
              small
              class="entry-chip-color justify-center align-center"
              style="border-radius: 2px;width: 80px !important;"
            >
              {{ item.total_time }}
            </v-chip>
          </template>
          <template v-slot:[`item.status`]="{ item }">
            <v-chip
              small
              class="entry-chip-color ma-0 d-flex justify-center align-center"
              style="border-radius: 2px;width: 80px !important;"
              :class="
                item.overdue && item.status != 'completed'
                  ? 'red-chip-color'
                  : item.status === 'active' && item.running
                  ? 'light-blue-chip-color'
                  : item.status === 'active' && !item.running
                  ? 'status-paused-chip-color'
                  : item.status === 'pending'
                  ? 'status-yellow-chip-color'
                  : item.status === 'completed' && item.archived_at != null
                  ? 'status-blue-chip-color'
                  : item.status === 'completed' && item.expired
                  ? 'expired-chip-color'
                  : item.status === 'completed'
                  ? 'green-chip-color'
                  : ''
              "
            >
              <span>
                {{
                  item.overdue && item.status != "completed"
                    ? "Overdue"
                    : item.status === "pending"
                    ? "Pending"
                    : item.status === "completed" && item.archived_at != null
                    ? "Archived"
                    : item.status === "completed" && item.expired
                    ? "Expired"
                    : item.status === "completed"
                    ? "Completed"
                    : item.status === "active" && item.running
                    ? "Active"
                    : item.status === "active" && !item.running
                    ? "Paused"
                    : ""
                }}</span
              >
            </v-chip>
          </template>
          <template v-slot:[`item.title`]="{ item }">
            <v-tooltip
              :disabled="$vuetify.breakpoint.xs"
              content-class="arrow-up"
              bottom
              color="#DCD8F3"
            >
              <template v-slot:activator="{ on }">
                <span
                  v-on="on"
                  class="text-capitalize dark-purple-text text-truncate  d-inline-block"
                  :class="item.title ? '' : 'grey--text font-italic'"
                  style="max-width: 200px; font-size: 13px"
                >
                  {{ item.title ? item.title : "No title" }}
                </span>
              </template>
              <span
                class="d-inline-block text-capitalize font-weight-bold dark-purple-text"
                style="max-width: 480px"
                :style="
                  $vuetify.breakpoint.xs || $vuetify.breakpoint.sm
                    ? 'word-wrap:break-word;'
                    : 'word-wrap:break-word;'
                "
              >
                <p class="body pa-0 ma-0">
                  {{ item.title ? item.title : "No Title" }}
                </p>
              </span>
            </v-tooltip>
          </template>
          <template v-slot:[`item.project_name`]="{ item }">
            <v-tooltip
              :disabled="$vuetify.breakpoint.xs"
              content-class="arrow-up"
              bottom
              color="#DCD8F3"
            >
              <template v-slot:activator="{ on }">
                <span
                  v-on="on"
                  class="text-capitalize dark-purple-text text-truncate d-inline-block"
                  :class="item.project_name ? '' : 'grey--text font-italic'"
                  style="max-width: 120px; font-size: 13px"
                  >{{
                    item.project_name ? item.project_name : "No Project"
                  }}</span
                >
              </template>
              <span
                class="d-inline-block text-capitalize dark-purple-text font-weight-bold"
                style="max-width: 480px"
                :style="
                  $vuetify.breakpoint.xs || $vuetify.breakpoint.sm
                    ? 'word-wrap:break-word;'
                    : 'word-wrap:break-word;'
                "
              >
                <p class="body pa-0 ma-0">
                  {{ item.project_name ? item.project_name : "No Project" }}
                </p>
              </span>
            </v-tooltip>
          </template>
        </v-data-table>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { snackbarMixin } from "@/mixins/snackbarMixin";
import { eventBus } from "@/main";
export default {
  mixins: [snackbarMixin],
  data: () => ({
    flag: true,
    headers: [
      {
        text: "Task Id",
        value: "id",
        sortable: false,
        class: "table-header-bg",
      },
      {
        text: "Project Name",
        value: "project_name",
        class: "table-header-bg",
        sortable: false,
      },
      {
        text: "Task Title",
        value: "title",
        class: "table-header-bg",
        sortable: false,
        width: "15vw",
      },
      {
        text: "Status",
        value: "status",
        class: "table-header-bg",
        cellClass: "px-0",
        sortable: false,
      },
      {
        text: "Total Time",
        value: "total_time",
        class: "table-header-bg",
        sortable: false,
        width: "7vw",
      },
    ],
  }),
  props: [
    "userId",
    "openMemberTasksModal",
    "fetchTaskEntriesLoader",
    "scheduleDetails",
    "entriesDetail",
  ],
  computed: {
    ...mapGetters(["getSelectedCompany", "getTaskTimeEntries"]),
  },
  watch: {
    flag(value) {
      !value
        ? this.$emit("update:openMemberTasksModal", false)
        : console.log("hi");
      if (value) console.log("value", value);
    },
  },
  methods: {
    closeDialog() {
      this.$emit("update:openMemberTasksModal", false);
    },
    // Redirection to Task Page
    redirect(item) {
      window.open(`task/${item.id}`);
    },
  },
};
</script>
<style>
#task-entries-table .v-data-table-header th {
  font-size: 13px;
  color: #2a206a;
}
.tables-border thead th:first-child {
  border-top-left-radius: 3px;
}
.tables-border thead th:last-child {
  border-top-right-radius: 3px;
}
</style>
